import '@babel/polyfill'
import $ from "jquery"

const selectors = {
    modal: '[data-modal]',
    modalClose: '[data-modal-close]',
    modalOpen: '[data-modal-open]',
    modalLink: '[data-modal-link]',
    modalTab: '[data-modal-tab]',
    isActive: '-active'
  }

export default () => {
    const modal = document.querySelector(selectors.modal)

    if (!modal) {
        return
    }
  
    const modalClose = modal.querySelector(selectors.modalClose)

    const modalOpen = document.querySelectorAll(selectors.modalOpen)
    let type = null

    const closeModal = function () {
        modal.classList.remove(selectors.isActive)
    }

    modalClose.addEventListener('click', (e) => {
        e.preventDefault()
        closeModal()
    })

    Array.from(modalOpen).map(el => {
        el.addEventListener('click', (e) => {
            e.preventDefault()
            type = el.dataset.modalOpen
            //const data = document.querySelector('[data-event-modal="' + type + '"]')

            /*if (data) {
                const meta = data.querySelector('[data-event-meta]')

                modal.querySelector('[data-modal-meta]').innerHTML = ''
                modal.querySelector('[data-modal-meta]').appendChild(meta)
                modal.classList.add(selectors.isActive)
            }*/
            modal.classList.add(selectors.isActive)
        })
    })

}
